import { Fragment } from 'react'
import { useRouter } from 'next/router'
import { GetStaticPropsContext, NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import MediaNews from '~/static-pages/media/pages/media-news/MediaNews.page'
import MediaPageWrapper from '~/static-pages/media/components/MediaPageWrapper/MediaPageWrapper'
import Metatags from '~/components/Metadata/Metatags'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { NavigationElement } from '~/static-pages/media/components/MediaPageWrapper/MediaPageWrapperNav/MediaPageWrapperNav.types'
import { getNewsItemsList, getRunningQueriesThunk, useGetNewsItemsListQuery } from '~/redux/apis/media.api'
import { usePageTitle } from '~/utils/tags'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import { GetProps } from '~/utils/pageWrapper/types'

const MediaNewsPage: NextPage = () => {
  const { t } = useTranslation('media')
  const { locale, isFallback } = useRouter()
  const { data = [] } = useGetNewsItemsListQuery({ language: locale as string }, { skip: isFallback })

  const dataWithSource = data.map((elem) => ({
    ...elem,
    source: new URL(elem.href).hostname.replace('www.', ''),
  }))

  const title = usePageTitle(t('newsTitle'))
  const metaDescription = t('newsMetaDescription')

  return (
    <Fragment>
      <Metatags metaDescription={metaDescription} title={title} />

      <DefaultLayout>
        <MediaPageWrapper activeNavElement={NavigationElement.NEWS}>
          <MediaNews items={dataWithSource} />
        </MediaPageWrapper>
      </DefaultLayout>
    </Fragment>
  )
}

export const getProps: GetProps =
  (store) =>
  async ({ locale }: GetStaticPropsContext) => {
    store.dispatch(getNewsItemsList.initiate({ language: locale as string }))
    await Promise.all(store.dispatch(getRunningQueriesThunk()))

    return {
      props: {
        namespaces: ['media', ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES],
      },
      revalidate: process.env.ENVIRONMENT === 'staging' ? 60 : false,
    }
  }

export const getStaticProps = getStaticPropsWrapper(getProps)
export default MediaNewsPage
